import {post, get} from '@/utils/request'

// 获取资金统计
export function getFundCountAPI(data) {
    return get({
        data,
        url: 'funds/pt-funds/statistics'
    })
}

// 获取会员统计
export function getMemberCountAPI(data) {
    return get({
        data,
        url: 'funds/pt-funds/member/count'
    })
}

// 获取资金列表
export function getFundListAPI(data) {
    return post({
        data,
        url: 'funds/pt-funds/detail'
    })
}

// 冻结资金
export function fundFreezeAPI(data) {
    return post({
        data,
        url: 'funds/wallets/frozen'
    })
}

// 解冻资金
export function fundUnfreezeAPI(data) {
    return post({
        data,
        url: 'funds/wallets/unfrozen'
    })
}


// 资金明细-获取资金明细列表
export function getFundDetailListAPI(data) {
    return post({
        data,
        url: 'funds/pt-funds/log'
    })
}